module.exports = __webpack_public_path__ + "img/navigation_four.3114aecf.png";